import React from "react";
import styles from "./ConfirmGenerateModal.module.scss";
import { Modal } from "antd";
import { CommonButtonTexts } from "../../../../enums/ButtonAttributesEnums";
import { ConfirmationModalConstants } from "./constants";

interface ConfirmGenerateModalProps {
  isOpen: boolean;
  handleClose: () => void;
  handleConfirm: () => void;
}

const ConfirmGenerateModal = ({
  isOpen,
  handleClose,
  handleConfirm,
}: ConfirmGenerateModalProps) => {
  const { MAIN_TEXT, WARNING_NOTE, MODAL_WIDTH, MODAL_HEADER } = ConfirmationModalConstants;

  return (
    <Modal
      visible={isOpen}
      okText={CommonButtonTexts.CONFIRM}
      cancelText={CommonButtonTexts.CANCEL}
      onOk={handleConfirm}
      onCancel={handleClose}
      width={MODAL_WIDTH}
      title={MODAL_HEADER}
    >
      <div className={styles.mainText}>{MAIN_TEXT}</div>
      <div className={styles.warningNote}>{WARNING_NOTE}</div>
    </Modal>
  );
};

export default ConfirmGenerateModal;
